// extracted by mini-css-extract-plugin
export default {"cardwarapper":"PartnersCard_cardwarapper__WMkh5","card":"PartnersCard_card__n19Ce","newsLink":"PartnersCard_newsLink__OcIPl"};